import React from 'react';
import cx from 'classnames';
var regionIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAA3NJREFUSA2tlU1IVFEUx3vjTG7aWBA6SlFEtYjoY1GCRAQRKkKZjos+cGxGjTAiMAqSMBAKoaIgcD7M1DZTEWgJfUBJUG4aSqjARUQTZkHpIhhNZ6bfebz7uNPMqIsu3Dnnnv//nHPPue/eMZbMM1KplCMcDlcmk8lq9FLDMNxIhDGO2yvmA7/f/5B1MlcYIxfQ1dVVhuMNAm6BM4M+gvxi8Vdh34mez3zncDhaSPTSwtJE1gSBQMBPgJsE/YlsLygo6PN4PL91z0gksmxycvIInAtwVpDkBEkCOkf0jATsvBZ7BMdhnKp9Pt+vf530dSgUWk4L75NkNz51jY2NER1PS9Dd3b12bm5uFML7kpKSXRUVFTM6OZc+NDSUH4vFhkmwyel0bm5oaPikuA6liCS4lAvPOLjY4OInXKqtEX12drZdpBp2Bb29vSunp6fHSXClqanpjCKIDAaDa7B3oO5BJtnAMLOVnn/VeZzdJfBWkrnBvgtmVxCPx8sB81wuV48AakhwejwCVoltgMAD6OXYRun/asUTCXYb4RBc2e0EgNsx/qB/HxQokkAXwZaSeCsHKKMZfRs2I5FIdOpcdv0Rs+xcYpnDTkDWQixpJQsDh31gEf3gRMd2D2yvGUX7wR5jKbHM4VSKbAg9pdZK4iDnZG9E2UWCZfAtu8Qyh+0Id4JZrAAlSfwMvZZ+r1M2S68Fe6psmizGPqHWdgKMrzEWctE2KlAk/T4HRrsTb/hKQjI5lyi2P8BtOpd3awPrIiuWCdkJCPQEi7w5R3Unr9f7GUwO7THzAFXut/QyDnxM53KPxHeGyyZcc9j3QFbs7joBvKjruQvfTMYif6i8COoYG+whcYtysysQA2AHM868i4NLkRaSFlferzjVyoW0R1oCuX2QPFSxA9nPi5lnM3MoFqcPfil+dbTUPmBxSUsgBpK8gFwPuYbnuAeZwRGeDMGmpqZuocoXVU9bn5uA9pPVmR7eweEY8xBPRZBAaWcl/mIDkvf/MG+Pj431a3FtNWcLBgcH31ZVVclfY1s0Gi1k/cj2QnG73fKH5Gc2EzysY7qetQJFoJIgAVrYbTNf2DVl51Cvoh/HfpLgUkXOkVF6NiatOMXlkqCdJCRuSp7z0/RcbPOORSWQCOxagl4WnSRnqc7UZf3fBm06T6K052Gh4H8B4vOOzqfHm/MAAAAASUVORK5CYII=";
var clsPrefix = 'tcpct-showroom-item';

var ShowroomDesc = function ShowroomDesc(props) {
  var fullAddress = props.fullAddress,
      serviceMessage = props.serviceMessage,
      name = props.name,
      onClick = props.onClick,
      onInquiryClick = props.onInquiryClick,
      style = props.style,
      className = props.className;
  var baseProps = {
    style: style,
    className: cx(clsPrefix, className)
  };
  return /*#__PURE__*/React.createElement("section", baseProps, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-block")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-name")
  }, /*#__PURE__*/React.createElement("div", null, name), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-serviceMessage")
  }, serviceMessage)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-region-item")
  }, /*#__PURE__*/React.createElement("i", {
    className: "".concat(clsPrefix, "-region-icon"),
    style: {
      backgroundImage: "url(".concat(regionIcon, ")")
    }
  }), fullAddress), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-footer")
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "".concat(clsPrefix, "-join-btn")
  }, "\u9032\u5165\u5C55\u793A\u9593"), /*#__PURE__*/React.createElement("div", {
    onClick: onInquiryClick,
    className: "".concat(clsPrefix, "-inquiry-btn")
  }, "\u4E00\u9375\u8A62\u50F9"))));
};

export default ShowroomDesc;